<template>
  <v-container style="width:640px">
    <v-row justify="center">
      <div class="text-sm-center">
        <h1>{{$t('errors.network.title')}}</h1>
        <p>{{$t('errors.network.description')}}</p>
      </div>
    </v-row>
    <v-row justify="center" class="mt-2">
      <TwilioWebcam ref="webcam" :test-mode="true"
                    :countdown="3"
                    @error="onError($event)"
                    @countdown-ended="onSuccess($event)"
                    v-if="success===null"
      ></TwilioWebcam>
       <v-alert color="success" v-else-if="success===true">{{$t('errors.network.success')}}</v-alert>
       <v-alert color="error" v-else-if="success===false">{{error}}</v-alert>
    </v-row>
    <v-row justify="center" class="mt-5" v-if="success===null">
      <v-btn color="primary" v-if="!active" @click="start()">{{$t('errors.network.start')}}</v-btn>
      <v-btn color="error" v-else-if="active" @click="stop()">{{$t('errors.network.stop')}}</v-btn>
    </v-row>
    <v-row justify="center" class="mt-5" v-if="success===false">
      <v-btn color="primary" @click="quit()">{{$t('general.quit')}}</v-btn>
    </v-row>
  </v-container>
</template>

<script>
    import TwilioWebcam from "../../components/webcam/TwilioWebcam";

    export default {
        components: {
          TwilioWebcam
        },
        name: "NetworkVideoCheck",
        data: () => ({
          success : null,
          active : false,
          error: null
        }),
        methods:{
          start(){
             this.active=true;
             this.$refs.webcam.start();
          },
          stop(){
            this.active=false;
            this.$refs.webcam.stop();
          },
          onError(){
            this.active=false;
            this.success=false;
            this.error=this.$t('errors.network.failed');
          },
          onSuccess(){
            if(this.active && this.success===null){
              this.active=false;
              this.success=true;
              setTimeout(()=>{
                 this.next();
              },1000);
            }

          },
          next() {
            this.$router.replace({name: 'JourneyOrientation'});
          },
          quit(){
            this.$store.dispatch('auth/logout',{navigate:true,clearAssessmenttoken:false});
          }
        }
    }
</script>

<style scoped>

</style>